import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Tooltip from "@mui/material/Tooltip";

type StatusTransitionButtonGroupProps = {
  anchorRef: any;
  statusTransitionLabel: string;
  tooltipText?: string;
  isDisabled: boolean;
  onAppointmentStatusChange: () => void;
  onToggleDropDown: () => void;
};

export default function StatusTransitionButtonGroup({
  anchorRef,
  statusTransitionLabel,
  tooltipText,
  isDisabled,
  onAppointmentStatusChange,
  onToggleDropDown
}: StatusTransitionButtonGroupProps) {
  return (
    <ButtonGroup
      ref={anchorRef}
      size="small"
      variant="contained"
      aria-label="status button"
      sx={{
        "& .MuiButton-root:first-child": {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          height: "100%"
        },
        "& .MuiButton-root:nth-child(2)": {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      }}
    >
      <Tooltip
        open={Boolean(tooltipText) ? undefined : false}
        title={tooltipText as string}
        placement="top"
        arrow
      >
        <Box>
          <Button disabled={isDisabled} onClick={onAppointmentStatusChange}>
            {statusTransitionLabel}
          </Button>
        </Box>
      </Tooltip>
      <Button size="small" onClick={onToggleDropDown}>
        <ArrowDropDownIcon />
      </Button>
    </ButtonGroup>
  );
}
